import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

/**
 * Shared layout for legal pages (Terms, Privacy, Refunds, Contact).
 * Mirrors the app's dark aesthetic while staying reader-friendly for
 * Stripe reviewers and end users.
 */
export default function LegalPage({ title, updated, children }) {
  return (
    <div className="min-h-[100dvh] bg-[#0B0A10] text-neutral-200">
      <div className="mx-auto max-w-3xl px-4 pt-safe-6 pb-24">
        <header className="mb-8 flex items-center gap-3">
          <Link
            to="/welcome"
            className="flex h-10 w-10 items-center justify-center rounded-full bg-white/5 text-white/70 hover:bg-white/10"
            aria-label="Back"
            data-testid="legal-back-link"
          >
            <ArrowLeft size={18} />
          </Link>
          <div className="flex-1">
            <div className="font-display text-xs uppercase tracking-[0.35em] text-violet-300/80 flex items-center gap-2">
              <ShieldCheck size={12} /> Legal
            </div>
            <h1 className="font-display text-3xl leading-tight text-white sm:text-4xl">{title}</h1>
            {updated && (
              <div className="mt-1 text-xs text-neutral-500">Last updated: {updated}</div>
            )}
          </div>
        </header>

        <article className="prose prose-invert max-w-none text-sm leading-relaxed text-neutral-300 [&_h2]:font-display [&_h2]:text-xl [&_h2]:text-white [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:font-display [&_h3]:text-lg [&_h3]:text-white [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:my-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:my-3 [&_li]:my-1 [&_a]:text-violet-300 [&_a:hover]:text-violet-200">
          {children}
        </article>

        <LegalFooter />
      </div>
    </div>
  );
}

export function LegalFooter() {
  return (
    <footer className="mt-16 border-t border-white/10 pt-6 text-xs text-neutral-500">
      <div className="flex flex-wrap gap-x-4 gap-y-2">
        <Link to="/terms" className="hover:text-violet-300" data-testid="footer-terms-link">Terms of Service</Link>
        <Link to="/privacy" className="hover:text-violet-300" data-testid="footer-privacy-link">Privacy Policy</Link>
        <Link to="/refunds" className="hover:text-violet-300" data-testid="footer-refunds-link">Refund Policy</Link>
        <Link to="/contact" className="hover:text-violet-300" data-testid="footer-contact-link">Contact</Link>
      </div>
      <div className="mt-3 text-neutral-600">
        © {new Date().getFullYear()} Immersive Character AI · An 18+ platform · Operated from Texas, USA
      </div>
    </footer>
  );
}
